import React, { useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { ToggleButtonGroup, ToggleButton } from "@material-ui/lab";

import HexFillOptions from "../Geofences/HexFillOptions";

import { GeofencesContext } from "../../context";
import { GeofencesEditModes } from "../../constants";

import buildAssetsUrl from "../../util/strings/buildAssetsUrl";

const useStyles = makeStyles((theme) => {
  const panelStyle = {
    display: "flex",
    alignItems: "center",
    padding: `0 ${theme.spacing(1)}px`,
    borderRadius: 2,
    background: theme.palette.background.paper,
    boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
    pointerEvents: "all",
  };

  return {
    toolsPanel: {
      width: "calc(100% - 20px)",
      height: theme.spacing(8),
      margin: 10,
      marginBottom: 0,
    },
    buttonsPanel: {
      ...panelStyle,
      marginRight: theme.spacing(1),
    },
    optionsPanel: {
      ...panelStyle,
      paddingLeft: theme.spacing(2),
      flexGrow: 1,
    },
    hexBrushButton: {
      "& img": { width: theme.spacing(3) },
      "&.Mui-disabled img": { opacity: 0.12 },
    },
  };
});

const ToolsPanel = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const {
    selectedZone,
    selectedLayer,
    sidewalksEditMode,
    updateSelectedZone,
    updateSelectedLayer,
    setSidewalksEditMode,
  } = useContext(GeofencesContext);

  const onChangeEditMode = (e, v) => {
    setSidewalksEditMode(v || GeofencesEditModes.default);

    if (selectedLayer.key) {
      updateSelectedLayer({ editMode: v === GeofencesEditModes.default ? null : v });
    }

    if (selectedZone.key) {
      updateSelectedZone({ editMode: v === GeofencesEditModes.default ? null : v });
    }
  };

  return (
    <Grid item container className={classes.toolsPanel}>
      <Grid item className={classes.buttonsPanel}>
        <ToggleButtonGroup
          value={sidewalksEditMode}
          size="small"
          exclusive
          onChange={onChangeEditMode}
        >
          <ToggleButton value={GeofencesEditModes.default}>
            <img src={buildAssetsUrl("geofences/default-cursor.svg")} alt="default" />
          </ToggleButton>
          {selectedZone.key ? (
            <ToggleButton value={GeofencesEditModes.polygonEdit}>
              <img src={buildAssetsUrl("geofences/polygon-icon.svg")} alt="polygon" />
            </ToggleButton>
          ) : (
            <ToggleButton value={GeofencesEditModes.polygonCreate}>
              <img src={buildAssetsUrl("geofences/polygon-plus-icon.svg")} alt="polygon-plus" />
            </ToggleButton>
          )}

          <ToggleButton value={GeofencesEditModes.hex}>
            {selectedZone.key
              ? <img src={buildAssetsUrl("geofences/hex-icon.svg")} alt="hex" />
              : <img src={buildAssetsUrl("geofences/hex-plus-icon.svg")} alt="hex" />
            }
          </ToggleButton>
          <ToggleButton
            className={classes.hexBrushButton}
            value={GeofencesEditModes.hexBrush}
            disabled={!selectedZone.key}
          >
            <img src={buildAssetsUrl("geofences/hex-brush.png")} alt="hex-brush" />
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Grid item className={classes.optionsPanel}>
        {(selectedZone.key || selectedLayer.key) && <HexFillOptions sidewalksMode />}
      </Grid>
    </Grid>
  );
};

export default ToolsPanel;
